function Apple() {
  return (
    <div className="text-6xl text-center p-2">
    🍎
    </div>
  )
}

export default Apple;
